import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import OnePage from "@/pages/OnePage";
import Leistungen from "@/pages/Leistungen";
import Branchen from "@/pages/Branchen";
import Ueber from "@/pages/Ueber";
import Kontakt from "@/pages/Kontakt";
import { Impressum, Datenschutz } from "@/pages/Legal";
import CookieConsent from "@/components/CookieConsent";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
        <div className="App min-h-screen flex flex-col">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<OnePage />} />
              <Route path="/leistungen" element={<Leistungen />} />
              <Route path="/branchen" element={<Branchen />} />
              <Route path="/ueber" element={<Ueber />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
          <CookieConsent />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
